// extracted by mini-css-extract-plugin
export default {"project_dashboard_page":"ProjectDashboard_project_dashboard_page__Q4TvN","project_dashboard_body":"ProjectDashboard_project_dashboard_body__EIeZ2"};